import { useEffect, useRef } from "react";
/**
 * Setzt ein State, ab wann der ServiceWorker aktiviert wurde (oder fehlgeschlagen)
 */
export default function useServiceWorker(
  setServiceWorkerActive,
  isApp,
  serviceWorkerActive
) {
  const fallbackTimer = useRef();

  const listenToServiceWorker = () => {
    if (!navigator || !navigator.serviceWorker) return;

    const test = () => {
      return;
      if (
        process.env.REACT_APP_VERSION.split(".")[2] > +"2.10.11".split(".")[2]
      ) {
        console.clear();
        console.log("wird neugeladen!");
        const registrations = navigator.serviceWorker
          .getRegistrations()
          .then((registrations) => {
            for (let registration of registrations) {
              registration.unregister();
            }
          });

        //@ts-ignore
        window.location.reload(true);
      }
    };
    console.log("run async");
    test();

    const serviceWorkerContainer = navigator.serviceWorker;
    // wenn der serviceWorker einmal installiert ist, called er kein event "controllerchange" beim zweiten aufruf
    serviceWorkerContainer.ready
      .then((serviceWorkerRegistration) => {
        console.log("service worker aktiviert - alles StaleWhileRevalidate");
        const serviceWorker = serviceWorkerRegistration.active;
        // timeout deshalb, weil auch wenn er activated ist, so ganz stimmt das nicht und den ersten fetch
        // verpennt der service worker dadurch, weil er grad aus dem "install" event kommt.
        // dadurch sind im offline modus wichtige dateien nicht vorhanden
        setTimeout(() => {
          if (serviceWorker && serviceWorker.state === "activated") {
            setServiceWorkerActive(true);
          } else {
            setServiceWorkerActive(false);
          }
        }, 1000);
      })
      .catch((e) => {
        console.log("Fehler während Serviceworker registrierung", e);
        setServiceWorkerActive(false);
      });
  };

  const fallbackServiceWorkerActivation = () => {
    // fallback, weil iphone in der webkit app den serviceworker irgendwie nicht aktiviert?
    if (serviceWorkerActive != null) {
      // wenn serviceworkeractive true/false -> clear und hau ab (sollte normalerweise nochmal hier reinkommen, wenn nicht wird fallback serviceworkeractive auf false gestzt)
      clearTimeout(fallbackTimer.current);
    } else {
      // wenn state noch komplett unset setz nen fallback timeout (beim ersten run des effects)
      fallbackTimer.current = setTimeout(() => {
        setServiceWorkerActive(false);
      }, 2000);
    }
  };

  useEffect(listenToServiceWorker, [isApp]);
  useEffect(fallbackServiceWorkerActivation, [serviceWorkerActive]);
}
